/* The Skin's Secret — image guard: never show a broken-image icon.
   Any failed / empty product image is swapped for an on-brand placeholder.
   Also fills empty src from data-src/data-srcset (lazy markup without JS). */
(function () {
  var PH = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 800 1000">' +
    '<rect width="800" height="1000" fill="#F6F4EF"/>' +
    '<rect x="24" y="24" width="752" height="952" fill="none" stroke="#E4DED2" stroke-width="2"/>' +
    '<text x="400" y="470" text-anchor="middle" font-family="Georgia,serif" font-size="40" fill="#1C1A17" letter-spacing="7">THE SKIN&#39;S SECRET</text>' +
    '<text x="400" y="530" text-anchor="middle" font-family="Georgia,serif" font-size="24" fill="#8A7A66" letter-spacing="3">Serum</text>' +
    '</svg>');
  function heal(img) {
    if (img.dataset.tsGuard === '1') return;
    img.dataset.tsGuard = '1';
    if (!img.getAttribute('src') || img.getAttribute('src') === '') {
      var lazy = img.getAttribute('data-src') || img.getAttribute('data-original');
      if (!lazy) {
        var ss = img.getAttribute('data-srcset') || img.getAttribute('srcset') || '';
        if (ss) { var parts = ss.split(','); for (var i = 0; i < parts.length; i++) { var u = parts[i].trim().split(' ')[0]; if (u && u.indexOf('data:') !== 0) { lazy = u; if (parts.length > 1 && i === 0) continue; break; } } }
      }
      if (lazy) img.setAttribute('src', lazy);
    }
    img.addEventListener('error', function () { if (img.src !== PH) { img.src = PH; img.classList.add('ts-img-ph'); } });
    if (img.complete && img.naturalWidth === 0 && img.getAttribute('src')) { img.src = PH; img.classList.add('ts-img-ph'); }
    if (!img.getAttribute('alt') && img.closest('[data-product-title]')) img.setAttribute('alt', 'The Skin\'s Secret product');
  }
  var queued = false;
  function scan() {
    if (queued) return; queued = true;
    requestAnimationFrame(function () { queued = false; var n = document.querySelectorAll('img:not([data-ts-guard])'); for (var i = 0; i < n.length; i++) heal(n[i]); });
  }
  scan();
  document.addEventListener('DOMContentLoaded', scan);
  document.addEventListener('shopify:section:load', scan);
  try { new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true }); } catch (e) {}
  window.addEventListener('pageshow', scan);
})();

/* Cart totals still print the shop format ("Rs.1,900.00 PKR") on phones.
   Desktop keeps that string untouched (client decision), so this runs only under 900px. */
(function () {
  try {
    function tidy() {
      var els = document.querySelectorAll('.cart-totals__total-value, .cart-totals *');
      for (var i = 0; i < els.length; i++) {
        var e = els[i];
        if (e.children.length) continue;
        var t = e.textContent;
        if (/Rs\.?[\d,]+\.00/.test(t)) {
          e.textContent = t.replace(/([\d,])\.00/g, '$1').replace(/\s*PKR\b/g, '');
        }
      }
    }
    tidy();
    document.addEventListener('DOMContentLoaded', tidy);
    window.addEventListener('load', tidy);
    setTimeout(tidy, 800); setTimeout(tidy, 2000); setTimeout(tidy, 3500);
    try { new MutationObserver(tidy).observe(document.body, { childList: true, subtree: true, characterData: true }); } catch (e) {}
  } catch (e) {}
})();

/* Mobile-only: on phones the theme hides the card quick-add button, so collection/search cards
   show title + price with no CTA at all. Add the same green WhatsApp pill the desktop cards use.
   Desktop is untouched (the theme's own quick-add + pill keep working there). */
(function () {
  try {
    if (!window.matchMedia || !window.matchMedia('(max-width: 899px)').matches) return;
    if (location.pathname.indexOf('/products/') === 0) return;
    var PHONE = '923317887825';
    var ICON = '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M20.5 11.6a8.5 8.5 0 0 1-12.5 7.4L3.5 20.5l1.5-4.4A8.5 8.5 0 1 1 20.5 11.6Z"/><path d="M9.1 8.2c.3-.1.6.1.7.3l.8 1.4c.1.3.1.5-.1.7l-.5.5c-.2.2-.2.4-.1.6a5.4 5.4 0 0 0 2.8 2.7c.2.1.4 0 .6-.1l.5-.5c.2-.2.4-.2.6-.1l1.5.8c.3.2.4.5.3.8a1.8 1.8 0 0 1-1.5 1.1 6.3 6.3 0 0 1-3.3-.8 8.7 8.7 0 0 1-3.1-3.1 4.4 4.4 0 0 1-.7-2.5 1.6 1.6 0 0 1 1.4-1.8Z"/></svg>';
    function titleOf(card) {
      var h = card.querySelector('h3,h2,[class*="heading"],[class*="title"]');
      var t = h ? h.textContent.trim() : '';
      var img = card.querySelector('img[alt]');
      if (!t && img) t = img.alt || '';
      return t.replace(/^\s*the\s+skin'?s\s+secret\s*[\u2013\u2014-]\s*/i, '').trim();
    }
    function go() {
      var links = document.querySelectorAll('a[href*="/products/"]');
      for (var i = 0; i < links.length; i++) {
        var a = links[i];
        var img = a.querySelector('img');
        if (!img || img.getBoundingClientRect().width < 70) continue;
        var card = a.closest('li') || a.parentElement.parentElement;
        if (!card || card.getAttribute('data-ts-card-cta') === '1') continue;
        if (card.querySelector('.ts-wa-buy')) { card.setAttribute('data-ts-card-cta', '1'); continue; }
        var holder = card.querySelector('[class*="card__content"], [class*="card__info"], [class*="card-info"]') || card;
        var pill = document.createElement('a');
        pill.className = 'ts-wa-buy ts-wa-buy--sm';
        pill.setAttribute('data-ts-card-cta-pill', '1');
        pill.setAttribute('target', '_blank');
        pill.setAttribute('rel', 'noopener');
        pill.style.margin = '10px 0 0';
        var href = a.getAttribute('href') || '';
        var name = titleOf(card) || document.title.split(/[\u2013|-]/)[0].trim();
        pill.href = 'https://wa.me/' + PHONE + '?text=' + encodeURIComponent('Hi! I want to order: ' + name + '\nhttps://theskinssecret.com' + href);
        pill.innerHTML = ICON + '<span class="ts-wa-buy__t">Order on WhatsApp</span>';
        holder.appendChild(pill);
        card.setAttribute('data-ts-card-cta', '1');
      }
    }
    go();
    document.addEventListener('DOMContentLoaded', go);
    window.addEventListener('load', go);
    setTimeout(go, 900); setTimeout(go, 2200);
  } catch (e) {}
})();

/* Product titles carry the "The Skin's Secret – " prefix in the product record. Cards, the cart and the
   bundle strip it at Liquid level; the PDP H1 comes from a theme-editor text block that refuses Liquid
   filters ("invalid filter with arguments"), so strip it in the browser — on desktop and mobile alike. */
(function () {
  try {
    function strip(el) {
      var t = el.textContent;
      if (!t) return;
      var s = t.replace(/^\s*The\s+Skin'?s\s+Secret\s*[\u2013\u2014-]\s*/i, '');
      if (s !== t) el.textContent = s;
    }
    function go() { var hs = document.querySelectorAll('h1'); for (var i = 0; i < hs.length; i++) strip(hs[i]); }
    go();
    document.addEventListener('DOMContentLoaded', go);
    window.addEventListener('load', go);
    setTimeout(go, 1200);
  } catch (e) {}
})();
